(function() {
    'use strict';

    angular
        .module('telestatApp')
        .controller('DivisionDialogController', DivisionDialogController);

    DivisionDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Division', 'Employee'];

    function DivisionDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Division, Employee) {
        var vm = this;

        vm.division = entity;
        vm.clear = clear;
        vm.save = save;
        /*
        vm.employees = Employee.query();
        */

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.division.id !== null) {
                Division.update(vm.division, onSaveSuccess, onSaveError);
            } else {
                Division.save(vm.division, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('telestatApp:divisionUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();
